import { useEffect, useMemo, useState } from 'react'
import {
  ArrowClockwise,
  CaretDown,
  CaretUp,
  Coin,
  PrinterFill,
} from 'react-bootstrap-icons'
import findProductsSvg from '../../assets/illustration/find-products.svg'
import { CustomButton } from '../../components/CustomButton'
import Navbar from '../../components/navbar/navbar'

import pdfmake from 'pdfmake'
import { ModalDevolucao } from './ModalDevolucao'

import { Form, Table } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { CustomSpinner } from '../../components/CustomSpinner'
import TrocasDevolucoesService from '../../services/database/TrocasDevolucoesService'
import { formatDate } from '../../utils/formatDate'

import ReactPaginate from 'react-paginate'
import { formatPrice } from '../../utils/formatPrice'

import { format } from 'date-fns'
import { useOrderTable } from '../../hooks/useOrderTable'
import './styles.css'

export function TrocasDevolucoes() {
  const [refunds, setRefunds] = useState([])
  const [selectedRefunds, setSelectedRefunds] = useState([])
  const [isLoadingRefunds, setIsLoadingRefunds] = useState(true)
  const [isModalRefundOpen, setIsModalRefundOpen] = useState(false)
  const [selectedTermFilter, setSelectedTermFilter] = useState('pes_razao')
  const [filterSearch, setFilterSearch] = useState('')

  const [itemOffset, setItemOffset] = useState(0)
  const [itemsPerPage] = useState(10)

  const endOffset = itemOffset + itemsPerPage
  const pageCount = Math.ceil(refunds.length / itemsPerPage)

  const {
    sortedArray: sortedRefunds,
    check,
    handleOrganize,
    orderType,
  } = useOrderTable(refunds, 'id')

  const currentRefunds = useMemo(() => {
    return sortedRefunds.slice(itemOffset, endOffset)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endOffset, sortedRefunds, itemOffset, orderType.field, orderType.type])

  const filteredResults = useMemo(() => {
    return currentRefunds.filter((refund) =>
      String(refund[selectedTermFilter])
        .toLowerCase()
        .includes(String(filterSearch).toLowerCase()),
    )
  }, [filterSearch, currentRefunds, selectedTermFilter])

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % refunds.length
    setItemOffset(newOffset)
  }

  function handleModalOpen() {
    setIsModalRefundOpen(true)
  }

  function handleModalClose() {
    setIsModalRefundOpen(false)
  }

  async function loadRefunds() {
    setIsLoadingRefunds(true)

    try {
      const refundsData = await TrocasDevolucoesService.getAll()

      setRefunds(refundsData)
    } catch (error) {
      console.log(error)
      toast.error('Erro ao buscar as devoluções')
    } finally {
      setIsLoadingRefunds(false)
    }
  }

  async function genProof() {
    const currentDate = format(new Date(), `dd/MM/yyyy 'ás' HH:ss`)

    const refundItems = selectedRefunds.map((refund) => [
      { text: refund.id_pedido, style: 'tableRow' },
      {
        text: `${refund.sku_produto} - ${refund.descricao}`,
        style: 'tableRow',
      },
      { text: refund.quantidade, style: 'tableRow' },
      { text: formatPrice(refund.valor_unitario), style: 'tableRow' },
      { text: formatPrice(refund.valor_total), style: 'tableRow' },
      {
        text: refund.acrescimo_saldo === 'S' ? 'Sim' : 'Não',
        style: 'tableRow',
      },
      { text: formatDate(refund.data_devolucao), style: 'tableRow' },
      { text: refund.nomefuncionario, style: 'tableRow' },
    ])

    const saldoTotal = selectedRefunds.reduce((acc, item) => {
      if (item.acrescimo_saldo === 'S') {
        acc = acc + item.valor_total
      }

      return acc
    }, 0)

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      content: [
        {
          text: 'Comprovante de Devolução',
          style: 'mainInfo',
        },
        {
          text: `Gerado em ${currentDate} por ${localStorage.username}`,
          style: 'baseText',
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            widths: [60, 'auto', 60, 60, 60, 60, 60, 60],
            body: [
              [
                { text: 'Pedido', style: 'tableRow' },
                { text: 'Produto', style: 'tableRow' },
                { text: 'Qtd Devolvida', style: 'tableRow' },
                { text: 'Preço Unitário', style: 'tableRow' },
                { text: 'Preço Total', style: 'tableRow' },
                { text: 'Acrésc/Saldo', style: 'tableRow' },
                { text: 'Data da Devolução', style: 'tableRow' },
                { text: 'Funcionário', style: 'tableRow' },
              ],
              ...refundItems,
            ],
          },
          margin: [0, 10],
        },
        {
          text: `Saldo/Crédito em Haver: ${formatPrice(saldoTotal)}`,
          margin: [0, 20],
          style: 'baseText',
        },
      ],
      styles: {
        defaultStyle: {
          fontSize: 16,
          bold: true,
        },
        baseText: {
          fontSize: 10,
          bold: true,
        },
        mainInfo: {
          fontSize: 16,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        tableRow: {
          fontSize: 8,
        },
      },
    }

    pdfmake.createPdf(docDefinition).open()
  }

  useEffect(() => {
    loadRefunds()
  }, [])

  return (
    <>
      <Navbar />
      <div
        className="mt-page"
        style={{
          background: '#ffffff',
        }}
      >
        <h1>Trocas e Devoluções</h1>
        <div
          style={{
            display: 'flex',
          }}
        >
          <CustomButton
            color="#0d6efd"
            onClick={handleModalOpen}
          >
            <Coin />
            Adicionar Devolução
          </CustomButton>

          <CustomButton
            color=" #b019ed "
            onClick={loadRefunds}
          >
            <ArrowClockwise />
            Recarregar
          </CustomButton>

          <CustomButton
            onClick={genProof}
            isDisabled={selectedRefunds.length === 0}
          >
            <PrinterFill />
            Gerar Comprovante
          </CustomButton>
        </div>
        <>
          {isLoadingRefunds ? (
            <div id="content">
              <CustomSpinner color="#0d6efd" />
            </div>
          ) : !isLoadingRefunds && refunds.length === 0 ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={findProductsSvg}
                style={{
                  width: 400,
                }}
              />

              <p>Sem dados disponíveis</p>
            </div>
          ) : (
            <div
              className="mt-4"
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Form.Label>Selecione o tipo de pesquisa</Form.Label>
              <div
                style={{
                  display: 'flex',
                  gap: 5,
                }}
              >
                <Form.Select
                  defaultValue={selectedTermFilter}
                  onChange={(e) => setSelectedTermFilter(e.target.value)}
                  style={{
                    width: '200px',
                  }}
                >
                  <option value="pes_razao">Cliente</option>
                  <option value="sku_produto">SKU</option>
                  <option value="id">ID Devolução</option>
                  <option value="id_pedido">Pedido</option>
                </Form.Select>

                <Form.Control
                  value={filterSearch}
                  onChange={(e) => setFilterSearch(e.target.value)}
                  placeholder="Digite aqui"
                  style={{
                    width: '400px',
                  }}
                />
              </div>

              <div>
                <Table
                  striped
                  bordered
                  hover
                  responsive
                >
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          checked={
                            selectedRefunds.length === filteredResults.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRefunds(filteredResults)
                            } else {
                              setSelectedRefunds([])
                            }
                          }}
                        />
                      </th>
                      <th onClick={() => handleOrganize('id')}>
                        <span>ID</span>
                        <CaretUp color={check('id', 'asc')} />
                        <CaretDown color={check('id', 'desc')} />
                      </th>
                      <th onClick={() => handleOrganize('id_pedido')}>
                        <span> Pedido</span>
                        <CaretUp color={check('id_pedido', 'asc')} />
                        <CaretDown color={check('id_pedido', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('descricao')}>
                        <span> Produto</span>
                        <CaretUp color={check('descricao', 'asc')} />
                        <CaretDown color={check('descricao', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('pes_razao')}>
                        <span>Cliente</span>
                        <CaretUp color={check('pes_razao', 'asc')} />
                        <CaretDown color={check('pes_razao', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('quantidade')}>
                        <span>Qtd Devolvida</span>
                        <CaretUp color={check('quantidade', 'asc')} />
                        <CaretDown color={check('quantidade', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('valor_unitario')}>
                        <span> Valor Unitário</span>
                        <CaretUp color={check('valor_unitario', 'asc')} />
                        <CaretDown color={check('valor_unitario', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('valor_total')}>
                        <span> Valor Total</span>
                        <CaretUp color={check('valor_total', 'asc')} />
                        <CaretDown color={check('valor_total', 'desc')} />
                      </th>

                      <th>
                        <span>Acréscimo Saldo</span>
                      </th>

                      <th onClick={() => handleOrganize('data_devolucao')}>
                        <span> Data de Devolução</span>
                        <CaretUp color={check('data_devolucao', 'asc')} />
                        <CaretDown color={check('data_devolucao', 'desc')} />
                      </th>

                      <th onClick={() => handleOrganize('nomefuncionario')}>
                        <span> Funcionário</span>
                        <CaretUp color={check('nomefuncionario', 'asc')} />
                        <CaretDown color={check('nomefuncionario', 'desc')} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredResults.map((refund) => (
                      <tr key={refund.id}>
                        <td>
                          <Form.Check
                            checked={selectedRefunds.includes(refund)}
                            onChange={() => {
                              const index = selectedRefunds.findIndex(
                                (ref) => ref.id === refund.id,
                              )

                              if (index > -1) {
                                setSelectedRefunds((prevState) =>
                                  prevState.filter(
                                    (ref) => ref.id !== refund.id,
                                  ),
                                )
                              } else {
                                setSelectedRefunds((prevState) => [
                                  ...prevState,
                                  refund,
                                ])
                              }
                            }}
                          />
                        </td>
                        <td>{refund.id}</td>
                        <td>{refund.id_pedido}</td>
                        <td
                          style={{
                            minWidth: 400,
                          }}
                        >
                          {refund.sku_produto} - {refund.descricao}
                        </td>
                        <td style={{ fontSize: '14px' }}>{refund.pes_razao}</td>
                        <td>{refund.quantidade}</td>
                        <td>{formatPrice(refund.valor_unitario)}</td>
                        <td>{formatPrice(refund.valor_total)}</td>
                        <td>
                          {refund.acrescimo_saldo === 'S' ? 'Sim' : 'Não'}
                        </td>
                        <td>{formatDate(refund.data_devolucao)}</td>
                        <td>{refund.nomefuncionario}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <ReactPaginate
                breakLabel="..."
                nextLabel="Próxima"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="Anterior"
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                activeClassName="active"
              />
            </div>
          )}
        </>
      </div>

      {isModalRefundOpen && (
        <ModalDevolucao
          isOpen={isModalRefundOpen}
          loadRefunds={loadRefunds}
          onClose={handleModalClose}
        />
      )}
    </>
  )
}
